<template>
	<div class="head-serch">
		<el-form
			class="form"
			ref="unitSearchForm"
			:model="unitSearchForm"
			label-width="100px"
			@submit.native.prevent
			@keyup.enter.native="searchHandler"
		>
			<el-form-item label="名称">
				<el-input v-model="unitSearchForm.name" placeholder="请输入名称" />
			</el-form-item>
		</el-form>
		<el-button class="filter-item" size="mini" type="success" icon="el-icon-search" @click="searchHandler">搜索</el-button>
	</div>
</template>

<script>
export default {
	data() {
		return {
			unitSearchForm: {
				name: ''
			}
		};
	},
	created() {},
	methods: {
		searchHandler() {
			this.$emit('searchForm', this.unitSearchForm);
		}
	}
};
</script>

<style>
.form {
	display: flex;
}
</style>
